/**
 * Purchase Invoice Download Formatter.
 */
window.purchaseInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    if (row.hash_name) {
        html += '<a href="/admin/purchase/invoices/download/'+row.purchase_invoice_id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
